module.exports = __webpack_public_path__ + "img/streets.0066b7f1.png";